import React from 'react'
import BaseComponent from '../../../application/baseComponent'
import { punditStore } from '../../stores/punditStore'
import userStore from '../../stores/userStore'
import { t } from '../../../providers/i18nProvider/i18nProvider'
import ExternalBetComponent from './punditExternalBetComponent'
import { getIsHybrid } from '../../../application/pageDataObject'
import { getIsIe, getIsDesktop } from '../../../utils/ua'

export default class PunditVbetGraphComponent extends BaseComponent {
  constructor(props) {
    super(props, [punditStore, userStore])
  }

  getState(props) {
    let { vBetData, selection, captions, showExternalBettingProvider, matchStarted } = punditStore
    let { isLoggedIn, state: { image: userImage } } = userStore
    return {
      vBetData,
      selection,
      captions,
      loggedIn: isLoggedIn,
      showExternalBettingProvider: showExternalBettingProvider && !matchStarted,
      userImage: userImage,
    }
  }

  getSvgAnimationForGraph(y, percent) {
    return !getIsIe() && getIsDesktop()
      ? {
          rectAnimation: `<animate attributeType="XML"
                                   attributeName="y"
                                   from="98%" to="${y}%"
                                   dur="1s" fill="freeze"/>`,
          textAnimation: `<animate attributeType="XML"
                                 attributeName="y"
                                 from="95%" to="${y - 5}%"
                                 dur="1s" fill="freeze"/>${percent}%`,
          animated: true,
        }
      : {
          textAnimation: `${percent}%`,
        }
  }

  calculateGraphData(graphData, selection) {
    let sum = graphData.reduce(function(a, b) {
      return +a + +b
    })
    let data = graphData.map(function(value) {
      let percent = sum > 0 ? Math.round(value / sum * 100) : 0
      let height = percent > 0 ? percent : 2
      height = height > 80 ? height - 20 : height
      let y = 100 - height
      return { height, y, percent }
    })

    return data.map((bar, index) => {
      let widthCounter = 33.25
      let { rectAnimation, textAnimation, animated = false } = this.getSvgAnimationForGraph(
        bar.y,
        bar.percent
      )
      return (
        <g key={index} className={`pundit-vbet-component__graph__bar" : ""} `}>
          <rect
            x={`${widthCounter * index + 7.5}%`}
            y={animated ? '100%' : `${bar.y}%`}
            height={`${bar.height}%`}
            width="18.5%"
            fill={`${+selection === index ? 'rgb(255,152,1)' : 'rgb(204,204,204)'}`}
            dangerouslySetInnerHTML={{
              __html: rectAnimation,
            }}
          />
          <text
            className={`pundit-vbet-component__graph__bar__percent ${index === selection
              ? 'pundit-vbet-component__graph__bar__percent--selection'
              : ''}`}
            x={`${widthCounter * index + 16 - bar.percent.toString().length * 1.35}%`}
            y={animated ? '98%' : `${bar.y - 5}%`}
            width="18.5%"
            dangerouslySetInnerHTML={{
              __html: textAnimation,
            }}
          />
        </g>
      )
    })
  }

  getCaptions(captions, selection) {
    return captions.map((value, index) => {
      return (
        <li
          key={`caption_${index}`}
          className={`pundit-vbet-component__graph__captions__label ${selection === index
            ? 'pundit-vbet-component__graph__captions__label--selection'
            : ''}`}
        >
          {value}
        </li>
      )
    })
  }

  getExternalBettingComponent(show) {
    return show ? (
      <div className="pundit-vbet-component__graph__bet">
        <ExternalBetComponent text={t('pundit.place_your_bet')} />
      </div>
    ) : (
      ''
    )
  }

  render() {
    let loggedInImage =
      this.state.loggedIn && !getIsHybrid() ? (
        <img className="pundit-section-heading__profile-img" src={this.state.userImage} />
      ) : (
        ''
      )
    let data =
      this.state.vBetData.length > 0
        ? this.calculateGraphData(this.state.vBetData, this.state.selection)
        : []
    return (
      <div className="pundit-vbet-component__graph">
        <div className="pundit-section-heading">
          {loggedInImage}
          <h1 className="pundit-section-heading__text">
            {this.state.matchStarted && this.state.selection === -1 ? (
              t('pundit.fan_predictions')
            ) : (
              t('pundit.your_prediction')
            )}
          </h1>
        </div>
        <div className="pundit-vbet-component__graph__container">
          <svg height="100%" className="pundit-vbet-component__graph__svg">
            {data}
            <line
              className="pundit-vbet-component__graph__line"
              x1="5%"
              y1="100%"
              x2="95%"
              y2="100%"
            />
          </svg>
          <ul className={`pundit-vbet-component__graph__captions`}>
            {this.getCaptions(this.state.captions, this.state.selection)}
          </ul>
        </div>
        {this.getExternalBettingComponent(this.state.showExternalBettingProvider)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/pundit/punditVbetGraphComponent.js